module.exports = __webpack_public_path__ + "static/img/logo-small.82b9c7a5.png";